import React from "react";
import PropTypes from "prop-types";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";
import Tools from "./JNSTools";

import "./styles/DashboardProjectDocuments.css";

function Dialog_AddWorkspace(props) {
  const createWorkspace = () => {
    const adminCreds = JSON.parse(
      Tools.decrypt(localStorage.getItem("adminCreds")),
    );
    const authString = Tools.getXmlBodyAuthString(props.creds);
    const urlString = Tools.getInstanceUrl(props.creds);
    props.waitHandler(true);
    props.setOpenDialog(false);
    const today = new Date();
    const createWorkspaceRequest =
      authString +
      '<Add type="Workspace"><Workspace><name>' +
      props.projectObject.name +
      " workspace</name><description>Created by OACC</description><open>1</open><userid>" +
      adminCreds.id +
      "</userid><date><Date><year>" +
      today.getFullYear() +
      "</year><month>" +
      (parseInt(today.getMonth()) + 1) +
      "</month><day>" +
      today.getDate() +
      "</day></Date></date></Workspace></Add></request>";

    Tools.fetchPost(createWorkspaceRequest, urlString, "Workspace").then(
      (rawWsRec) => {
        const wsRec = Tools.xmlToArray(rawWsRec.xml);
        const wsId = wsRec[0].id;

        const createLinkRequest =
          authString +
          '<Add type="Workspacelink"><Workspacelink><workspaceid>' +
          wsId +
          "</workspaceid><recordid>" +
          props.projectObject.id +
          "</recordid><table_name>project</table_name></Workspacelink></Add></request>";
        Tools.fetchPost(createLinkRequest, urlString).then(() => {
          //console.log("link created");
          //workspaceid.current = wsId;
          sessionStorage.setItem("tempWorkspaceId", wsId);
          props.waitHandler(false);
          props.setOpenConfirmation(true);
        });
      },
    );
  };
  return (
    <DialogContent
      sx={{
        overflow: "hidden",
        padding: "0px",
        backgroundColor: "#ed6c02",
      }}
    >
      <Alert
        variant="filled"
        onClose={props.handleAlertClose}
        severity="warning"
        sx={{
          width: "95%",
          fontSize: "large",
          padding: "0px",
          margin: "5px",
        }}
      >
        <Typography sx={{ padding: "25px" }}>
          This project does not have an associated Openair workspace. In order
          to add links a workspace must be created and linked to this project.
          Click &quot;OK&quot; to create a workspace and link it to this
          project.
        </Typography>
        <DialogActions sx={{ paddingRight: "30px" }}>
          <Button
            className="settingsButtonActive"
            variant="filled"
            value="OK"
            onClick={createWorkspace}
            sx={{ margin: "0px 10px 0px 0px !important" }}
          >
            OK
          </Button>
          <Button
            className="settingsButtonActive"
            variant="filled"
            value="Cancel"
            onClick={props.handleClose}
            sx={{ margin: "0px !important" }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Alert>
    </DialogContent>
  );
}

export default Dialog_AddWorkspace;

Dialog_AddWorkspace.propTypes = {
  handleClose: PropTypes.func,
  handleAlertClose: PropTypes.func,
  waitHandler: PropTypes.func,
  creds: PropTypes.object,
  projectObject: PropTypes.object,
  setOpenDialog: PropTypes.func,
  setOpenConfirmation: PropTypes.func,
};
